
import $ from "jquery"


const TOGGLE_SELECTOR = "[data-toggle='display'][data-target]"

const INIT_DONE_CLASS_NAME = "js--toggle-display--init-done"


// === Hide toggle target on start or after AJAX ===
function initOneElement(element: Element) {
  const $this = $(element)

  if ($this.hasClass(INIT_DONE_CLASS_NAME)) {
    return
  }
  else {
    $this.addClass(INIT_DONE_CLASS_NAME)
  }

  const $container = $this.parents($this.data("parent") || "body")
  const targetSelector = $this.data("target")
  const $target = $container.find(targetSelector)

  // Use this class name as a flag of processed
  if (!$this.hasClass("js-toggle-display-init-done")) {
    $this.addClass("js-toggle-display-init-done")

    if ($this.data("hide") != null) {
      return $target.hide()
    }
  }

  $this.on("click", (e) => {
    if ($this.data("effect") === "slide") {
      $target.slideToggle()
    }
    else if ($this.data("effect") === "fade") {
      $target.fadeToggle()
    }
    else {
      $target.toggle()
    }

    if ($this.data("oneoff") != null) {
      $this.hide()
    }

    e.preventDefault()
  })
}

const initAllMatchingElements = () => {
  $(TOGGLE_SELECTOR).each((_idx, element) => {
    initOneElement(element)
  })
}

const onLoad = () => {
  // On document ready
  initAllMatchingElements()

  // On AJAX success
  $(document).ajaxSuccess(() => {
    initAllMatchingElements()
  })
  // === Hide toggle target on start or after AJAX ===
}


export default {
  onLoad:                   onLoad,
  initAllMatchingElements:  initAllMatchingElements,
}
